import React, { useState } from "react";
import styled from "styled-components";
import { AddIcon, FacebookLogo, FlipkartIconSmall, FlipkartLogo, InstagramIconSmall, StyledAddIcon, SubIcon, X_icon, YouTubeRedIcon } from "../../Common/SvgIcon/CommonSvgIcons";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 200px);
  gap: 10px;

  & > .category {
  font-family: inherit;
    font-weight: 700;
    font-size: 16px;
    text-transform: capitalize;
    color:rgba(42, 41, 41, 1);
    
    text-align: justify;
  }
`;

const ChannelTabWrapper = styled.div`
  width: 198px;
  height: 31px;
  display: grid;
  border: 1px solid rgba(181, 181, 181, 1);
  border-radius: 4px;
  grid-template-columns: 30px 1fr 30px;
  align-items: center;
  padding: 8px;
  align-content: space-evenly;

  & > input {
    width: 19px;
    height: 19px;
  }

  & > .addIcon {
    height: 22px;
    width: 25px;
    cursor:pointer;

    & > svg {
    width:19px;
    height:19px;
    }
  }
`;
const PforText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
  display: inline-block;
  font-family: inherit;
  font-weight: 400  !important;
  font-size: 14px  !important;
  line-height: 24px;
  letter-spacing: 0%;
  text-transform: capitalize;
  color:  rgba(42, 41, 41, 1);

  text-align: justify;
  margin: 0px !important;
`;

const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  // cursor: pointer;
`;
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;
const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  display: none;
`;

const StyledRadio = styled.span`
  width: 19px;
  height: 19px;
  background:white;
  border: 
   ${({ checked, disabled }) =>
        disabled ? '1px solid black' : checked ? '1px solid green' : '1px solid black'};
  border-radius: 50%;   // 🔥 circle for radio
  transition: all 150ms;
  position: relative;

  &::after {
    content: '';
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    position: absolute;
    top: 6px;
    left: 6px;
    width: 7px;
    height: 7px;
    background: ${(props) => props?.is_custom ? props?.is_custom : 'green'};
    border-radius: 50%;
  }
`;

const ExpandedDiv = styled.div`
  padding: 6px;
  border: 1px solid rgba(181, 181, 181, 1);
  border-radius: 6px;
  margin-top: 6px;
  width: 470px;
  position: ${(props) => props?.category == 'Enterprise' ? 'absolute' : ''};
  right:  ${(props) => props?.category == 'Enterprise' ? '80px' : ''} ;
  top: ${(props) => props?.category == 'Enterprise' ? '300px' : ''};
  background:rgba(154, 191, 194, 0.1);
  display:grid;
  grid-template-columns:1fr 1fr 1fr;
    max-height: 160px;
    overflow: auto;
 &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(154, 191, 194, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(217, 217, 217, 1);
    
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(154, 191, 194, 0.8);
  }
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  font-family: inherit;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-transform: capitalize;
  color:  rgba(42, 41, 41, 1);

  text-align: justify;
  margin: 0px;
  &:hover span {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipText = styled.span`
  visibility: hidden;
  width: max-content;
  max-width: 300px;
  background-color: #333;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 6px 8px;
  position: fixed;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.3s ease;
  white-space: normal;
  pointer-events: none;
  transform: translateX(-70%) translateY(-100%);
  font-weight: 400 !important;
  font-size: 14px !important;

  &::after {
    content: '';
    position: absolute;
    top: 100%; /* Arrow on bottom */
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
    font-weight: 400  !important;
    font-size: 14px  !important;
  }
`;


const ExpandDataWrapper = styled.div`
    gap: 10px;
    display: grid;
    grid-template-columns: 20px 1fr;
    word-break: break-all;
    margin-bottom: 12px;
    align-items: start;
    & > input {
    
    width: 18px;
    height: 18px;
    }
    & > p {
  font-family: inherit;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0%;
    text-transform: capitalize;
    color:  rgba(42, 41, 41, 1);

    text-align: justify;
    margin: 0px;
    }
`;

const SvgDiv = styled.div`
    display: flex;
    // gap:${(props) => props?.platform == 'X' ? '' : '10px'};
    // margin-left: ${(props) => props?.platform == 'X' ? '' : '8px'};
    // justify-content : ${(props) => props?.platform == 'X' ? 'center' : ''};
    justify-content:center;
    justify-content: flex-start;
    align-items: center;

  font-family: inherit;
    font-weight: 400;
    font-size: 14px;
    text-transform: capitalize;


        & > svg {
        width:25px;
        height:25px;
            // width:${(props) => props?.platform == 'X' ? '25px' : '20px'};
            // height:${(props) => props?.platform == 'X' ? '25px' : '20px'};
        }
`;

const AcountGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
`;

const SpanTitle = styled.span`
  font-family: inherit;
    font-weight: 600;
    font-size: 14px;
    text-transform: capitalize;
    color: rgb(42, 41, 41);
    margin-left: 8px;
    `;

const RenderChannelRadio = ({
    personalDetailsData,
    category,
    activePlatform,
    setActivePlatform,
    data,
    ChannelData,
    handleChildBoxChecked,
    subSectionChecked
}) => {
    return (
        <Wrapper>
            <div className="category">{category} Channels</div>

            {ChannelData?.map((platform, idx) => {
                // 🔹 group ONLY for active platform
                const groupedBySearchType = (data?.[platform?.title] || []).reduce(
                    (acc, item, originalIndex) => {
                        const key = item.search_type; // 'user' | 'hashtag'
                        if (!acc[key]) acc[key] = [];

                        acc[key].push({
                            ...item,
                            _originalIndex: originalIndex, // ✅ store real index
                        });

                        return acc;
                    },
                    {}
                );


                return (
                    <React.Fragment key={platform?.title + idx}>
                        {/* ================= PLATFORM ROW ================= */}
                        <ChannelTabWrapper style={{ border: "none" }}>
                            <CheckboxLabel>
                                <HiddenRadio
                                    name={`${category}-channel`}
                                    checked={platform?.isChecked}
                                    onClick={() => subSectionChecked(platform?.title, category)}
                                    disabled={platform?.disable}
                                />
                                <StyledRadio
                                is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'green'}
                                    checked={platform?.isChecked}
                                    disabled={platform?.disable}
                                />
                            </CheckboxLabel>

                            <SvgDiv platform={platform?.title}>
                                {platform?.title === "Instagram" && InstagramIconSmall}
                                {platform?.title === "Facebook" && FacebookLogo}
                                {platform?.title === "YouTube" && YouTubeRedIcon}
                                {platform?.title === "X" && X_icon}
                                {platform?.title === "flipkart" && FlipkartIconSmall}
                                {platform?.title === "Enterprise" && "Enterprise"}
                                <SpanTitle>{platform?.title === "X" ? `(Twitter)` : platform?.title}</SpanTitle>
                            </SvgDiv>

                            <div
                                className="addIcon"
                                onClick={() =>
                                    !platform?.disable &&
                                    setActivePlatform(
                                        activePlatform === platform?.title ? "" : platform?.title
                                    )
                                }
                            >
                                {activePlatform === platform?.title ? SubIcon : AddIcon}
                            </div>
                        </ChannelTabWrapper>

                        {/* ================= EXPANDED AREA ================= */}
                        {activePlatform === platform?.title &&
                            data?.[platform?.title]?.length > 0 && (
                                <ExpandedDiv category={category} style={{
                                    gridTemplateColumns: platform?.title === "Instagram" ? '1fr' : '1fr 1fr 1fr'
                                }}>

                                    {/* ===== INSTAGRAM GROUPED VIEW ===== */}
                                    {platform?.title === "Instagram" && (
                                        <>
                                            {/* ACCOUNTS */}
                                            {groupedBySearchType.user && (
                                                <>
                                                    <div style={{ fontWeight: 600, marginBottom: 10, textAlign: 'left',color: 'black',fontFamily: 'Inter'}}>
                                                        Accounts
                                                    </div>
                                                    <AcountGrid>
                                                        {groupedBySearchType.user.map((i, iIdx) => (
                                                            <ExpandDataWrapper key={`user-${iIdx}`}>
                                                                <CheckboxLabel>
                                                                    <HiddenRadio
                                                                        name="instagram-child"
                                                                        checked={i?.isChecked}
                                                                        onClick={() =>
                                                                            handleChildBoxChecked(
                                                                                platform?.title,
                                                                                category,
                                                                                i?._originalIndex
                                                                            )
                                                                        }
                                                                    />
                                                                    <StyledRadio is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'green'} checked={i?.isChecked} />
                                                                </CheckboxLabel>

                                                                <TooltipWrapper>
                                                                    <PforText>{i?.title}</PforText>
                                                                    <TooltipText>{i?.title}</TooltipText>
                                                                </TooltipWrapper>
                                                            </ExpandDataWrapper>
                                                        ))}

                                                    </AcountGrid>

                                                </>
                                            )}

                                            {/* HASHTAGS */}
                                            {groupedBySearchType.hashtag && (
                                                <>
                                                    <div
                                                        style={{
                                                            fontWeight: 600,
                                                            margin: "12px 0 10px",textAlign: 'left',color: 'black',fontFamily: 'Inter'
                                                        }}
                                                    >
                                                        Hashtags
                                                    </div>
                                                    <AcountGrid>
                                                        {groupedBySearchType.hashtag.map((i, iIdx) => (
                                                            <ExpandDataWrapper key={`hashtag-${iIdx}`}>
                                                                <CheckboxLabel>
                                                                    <HiddenRadio
                                                                        name="instagram-child"
                                                                        checked={i?.isChecked}
                                                                        onClick={() =>
                                                                            handleChildBoxChecked(
                                                                                platform?.title,
                                                                                category,
                                                                                i?._originalIndex
                                                                            )
                                                                        }
                                                                    />
                                                                    <StyledRadio is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'green'} checked={i?.isChecked} />
                                                                </CheckboxLabel>

                                                                <TooltipWrapper>
                                                                    <PforText>{i?.title}</PforText>
                                                                    <TooltipText>{i?.title}</TooltipText>
                                                                </TooltipWrapper>
                                                            </ExpandDataWrapper>
                                                        ))}
                                                    </AcountGrid>

                                                </>
                                            )}
                                        </>
                                    )}

                                    {/* ===== NON-INSTAGRAM PLATFORMS ===== */}
                                    {platform?.title !== "Instagram" &&
                                        data?.[platform?.title]?.map((i, iIdx) => (
                                            <ExpandDataWrapper key={`${platform.title}-${iIdx}`}>
                                                <CheckboxLabel>
                                                    <HiddenRadio
                                                        name={`${platform?.title}-child`}
                                                        checked={i?.isChecked}
                                                        onClick={() =>
                                                            handleChildBoxChecked(
                                                                platform?.title,
                                                                category,
                                                                iIdx
                                                            )
                                                        }
                                                    />
                                                    <StyledRadio is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'green'} checked={i?.isChecked} />
                                                </CheckboxLabel>

                                                <TooltipWrapper>
                                                    <PforText>{i?.title}</PforText>
                                                    <TooltipText>{i?.title}</TooltipText>
                                                </TooltipWrapper>
                                            </ExpandDataWrapper>
                                        ))}
                                </ExpandedDiv>
                            )}
                    </React.Fragment>
                );
            })}
        </Wrapper>
    );
};


export default RenderChannelRadio;


